import React from 'react';
import { Star, Quote } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    name: 'Martín',
    age: 28,
    city: 'Buenos Aires',
    quote: 'Empecé sin saber nada de detailing. Gracias al Método Detailing Pro, en menos de un mes ya tenía mis primeros clientes. La guía de precios fue clave para animarme a cobrar bien.',
    initials: 'M'
  }, {
    name: 'Lucía',
    age: 32,
    city: 'Córdoba',
    quote: 'Tenía miedo de arruinar la pintura de los autos. El curso me dio la confianza y el conocimiento para trabajar de forma profesional. Ahora genero ingresos extra los fines de semana.',
    initials: 'L'
  }, {
    name: 'Diego',
    age: 24,
    city: 'Rosario',
    quote: 'Dejé de perder tiempo mirando videos sueltos en YouTube. Este método te explica todo paso a paso, desde los productos hasta cómo conseguir clientes. 100% recomendado.',
    initials: 'D'
  }, {
    name: 'Camila',
    age: 30,
    city: 'Mendoza',
    quote: 'Nunca pensé que podía generar ingresos con algo que me apasiona. El bono de los primeros 10 clientes me cambió la perspectiva. Ya tengo agenda completa los sábados.',
    initials: 'C'
  }, {
    name: 'Fernando',
    age: 35,
    city: 'La Plata',
    quote: 'Trabajaba en una oficina y quería un cambio. Con el Método Detailing Pro aprendí una habilidad real que me permite ganar bien. La mejor inversión que hice.',
    initials: 'F'
  }];
  return <section className="bg-[#0E1F3D] py-20 px-4" data-id="element-233">
      <div className="max-w-6xl mx-auto" data-id="element-234">
        <div className="text-center mb-16" data-id="element-235">
          <h2 className="text-4xl md:text-5xl font-black text-white uppercase tracking-tight" data-id="element-236">
            Lo que dicen nuestros alumnos
          </h2>
          <div className="w-24 h-2 bg-[#D4AF37] mx-auto mt-6" data-id="element-237"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-238">
          {testimonials.map((testimonial, index) => <div key={index} className={`bg-[#132847] p-8 rounded-2xl border border-[#1E3A5F] relative ${index === 4 ? 'md:col-span-2 lg:col-span-1 lg:col-start-2' : ''}`} data-id="element-239">
              <Quote className="absolute top-6 right-6 w-12 h-12 text-[#1E3A5F]" data-id="element-240" />

              <div className="flex gap-1 mb-6" data-id="element-241">
                {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 text-[#D4AF37] fill-[#D4AF37]" data-id="element-242" />)}
              </div>

              <p className="text-gray-300 text-lg italic mb-8 relative z-10 font-medium" data-id="element-243">
                "{testimonial.quote}"
              </p>

              <div className="flex items-center gap-4 mt-auto" data-id="element-244">
                <div className="w-12 h-12 rounded-full bg-gradient-to-br from-[#D4AF37] to-[#B8860B] flex items-center justify-center text-black font-bold text-xl shadow-md" data-id="element-245">
                  {testimonial.initials}
                </div>
                <div data-id="element-246">
                  <h4 className="font-bold text-white text-lg" data-id="element-247">
                    {testimonial.name}, {testimonial.age}
                  </h4>
                  <p className="text-gray-400 text-sm" data-id="element-248">{testimonial.city}</p>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}